// import React from "react";
// import "./SoftwareSkill.css";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";

// function SoftwareSkill(props) {
//   return (
//     <div>
//       <div className="software-skills-main-div" style={{overflow: 'hidden', position:'relative'}}>
//         <ul className="dev-icons">
//           {props.logos.map((logo, i) => {
//             return (
//               <OverlayTrigger
//                 key={logo.skillName}
//                 placement={"top"}
//                 overlay={
//                   <Tooltip id={`tooltip-top`} key={'tooltip'+i}>
//                     <strong>{logo.skillName}</strong>
//                   </Tooltip>
//                 }
//                 container={document.body}
//               >
//                 <li key={'li-skill'+i} className="software-skill-inline" name={logo.skillName} style={{ position: 'relative'}}>
//                   <span
//                     className="iconify"
//                     data-icon={logo.fontAwesomeClassname}
//                     style={logo.style}
//                     data-inline="false"
//                   ></span>
//                 </li>
//               </OverlayTrigger>
//             );
//           })}
//         </ul>
//       </div>
//     </div>
//   );
// }

// export default SoftwareSkill;

import React from "react";
import "./SoftwareSkill.css";
import { Tooltip } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css'

const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = this;
    if (tid) clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

// Override ResizeObserver
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback) {
    super(debounce(callback, 20));
  }
};

function SoftwareSkill(props) {
  // const ro = new ResizeObserver((entries, observer) => {
  //   // Changing the body size inside of the observer
  //   // will cause a resize loop and the next observation will be skipped
  //   document.body.style.width = '100%';
  //   });
    
  //   // Listen for errors
  //   window.addEventListener('error', e => console.log(e.message));
    
  //   // Observe the body
  //   ro.observe(document.body);
  
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {props.logos.map((logo, i) => (
            <li
              key={'li-skill' + i}
              className="software-skill-inline"
              name={logo.skillName}
              data-tooltip-id={`tooltip-${i}`} // Unique ID for each tooltip
              data-tooltip-content={logo.skillName} // Tooltip content
            >
              <span
                className="iconify"
                data-icon={logo.fontAwesomeClassname}
                style={logo.style}
                data-inline="false"
              ></span>
              {/* Tooltip for the current item */}
              <Tooltip id={`tooltip-${i}`} place="top" resizeObserver={false} style={{ fontSize: '17px'}} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default SoftwareSkill;

// import React from "react";
// import "./SoftwareSkill.css";
// import Tooltip from "@mui/material/Tooltip";

// function SoftwareSkill(props) {
//   return (
//     <div>
//       <div className="software-skills-main-div">
//         <ul className="dev-icons">
//           {props.logos.map((logo, i) => (
//             <li
//               key={'li-skill' + i}
//               className="software-skill-inline"
//               name={logo.skillName}
//             >
//               <Tooltip title={logo.skillName} arrow placement="top">
//                 <span
//                   className="iconify"
//                   data-icon={logo.fontAwesomeClassname}
//                   style={logo.style}
//                   data-inline="false"
//                 ></span>
//               </Tooltip>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// }

// export default SoftwareSkill;


